import React from "react"
// import Footer from "components/navigation/app/Footer"
import Header from "components/navigation/app/Header"
import Sidebar from "components/navigation/admin/Sidebar"

const AdminWrapper = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col flex-shrink-0 antialiased bg-white text-gray-600">
            <Header />
            <div className="mt-16 flex-1 h-full flex bg-gray-100 ">
                {/* <div className="bg-green-100 w-1/6 hover:w-1/3">Sidebar</div> */}
                <Sidebar />
                <div className="w-full">{children}</div>
            </div>
        </div>
    )
}

export default AdminWrapper
